window.arDocumentsStatusFreelancerCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        classes: row.status_freelancer_cell_style
    };
};
